import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private readonly BASE_URL = '/api/v1';

  constructor(private http: HttpClient) { }

  getBoricaPayload(data) : Observable<any> {
    return this.http.post(`${this.BASE_URL}/order`, data);
  }

  sendPolicyData(dueId:string, data) {
    return this.http.put(`${this.BASE_URL}/payment/${dueId}`, data);
  }

  getBoricaPayloadOldProtocol(data) {
    return this.http.post<any>(`${this.BASE_URL}/old-protocol/order`, data);
  }

  handleBoricaResponse(data) {
    return this.http.post(`${this.BASE_URL}/borica-old-protocol`, data);
  }
}
